import React, { ReactElement, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import AppModal from "components/shared/modal/AppModal";

import { postEnableCoupon } from "redux/handlers/couponHandler";

import { useAppDispatch } from "hooks/reduxHook";

const EnableCoupon = ({
 id,
 reloadData,
 closeMenu
}: {
 id: number;
 reloadData?: () => void;
 closeMenu: () => void;
}): ReactElement => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const [openModal, setOpenModal] = useState<boolean>(false);
 const [loading, setLoading] = useState<boolean>(false);
 const [startDate, setStartDate] = useState(dayjs());
 const [endDate, setEndDate] = useState(dayjs().add(1, "day"));

 const handleOpen = () => setOpenModal(true);
 const handleClose = () => setOpenModal(false);

 const handleConfirm = async () => {
  setLoading(true);
  await dispatch(
   postEnableCoupon(id, startDate.format("YYYY/MM/DD"), endDate.format("YYYY/MM/DD"))
  );
  setLoading(false);
  reloadData && reloadData();
  handleClose();
  closeMenu();
 };

 return (
  <>
   <MenuItem onClick={() => handleOpen()}>
    <FormattedMessage id="configurator.coupon.enableCoupon" />
   </MenuItem>
   <AppModal
    open={openModal}
    close={handleClose}
    title={intl.formatMessage({ id: "configurator.coupon.enableCoupon" })}
    handleClose={handleClose}
    disabled={loading}
    handleConfirm={handleConfirm}>
    <Stack spacing={2}>
     <Typography>
      <FormattedMessage id="configurator.coupon.enableCouponMessage" />
     </Typography>
     <DatePicker
      label={<FormattedMessage id="configurator.coupon.activationDate" />}
      value={startDate}
      disablePast
      onChange={(newValue) => setStartDate(newValue?.startOf("day") || dayjs().startOf("day"))}
     />
     <DatePicker
      label={<FormattedMessage id="configurator.coupon.expireDate" />}
      value={endDate}
      disablePast
      onChange={(newValue) => setEndDate(newValue?.startOf("day") || dayjs().startOf("day"))}
     />
    </Stack>
   </AppModal>
  </>
 );
};

export default EnableCoupon;
